import { PlusIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import FieldsetContainer from '@/components/shared/FieldsetContainer';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Button, Loading } from '@/components/ui/daisy';
import useFormList from '@/data/hook/shared/useFormList';
import { CreateCourseModule } from '@/data/services/courseModuleServices';
import ModuleInlineForm from './ModuleInlineForm';

type ModuleFormListProps = {
  modulesCount: number;
  onSubmit: (data: CreateCourseModule) => void;
  isLoading: boolean;
};

export default function ModuleFormList({
  modulesCount,
  onSubmit,
  isLoading,
}: ModuleFormListProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.modulesTab',
  });
  const { openForms, addForm, removeForm, handleFormSubmit } =
    useFormList<CreateCourseModule>({ onSubmit });

  return (
    <div className="flex flex-col gap-6">
      <ConditionalRenderer condition={isLoading}>
        <FieldsetContainer className="flex justify-center items-center py-5">
          <Loading variant="spinner" size="md" color="primary" />
        </FieldsetContainer>
      </ConditionalRenderer>
      {openForms.map(formId => (
        <ModuleInlineForm
          key={formId}
          onSubmit={handleFormSubmit(formId)}
          onCancel={() => removeForm(formId)}
          isLoading={isLoading}
          order={modulesCount + 1}
        />
      ))}
      <FieldsetContainer>
        <Button size="md" onClick={addForm} className="bg-base-300">
          <PlusIcon className="w-4 h-4" />
          {t('addModule')}
        </Button>
      </FieldsetContainer>
    </div>
  );
}
